import React, { createContext, useContext, useState, useCallback } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isPinned, setIsPinned] = useState(false);
  const [activeGroup, setActiveGroup] = useState(null);
  const [hasMultipleItems, setHasMultipleItems] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const togglePinned = useCallback(() => {
    setIsPinned((prev) => !prev);
  }, []);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen((prev) => !prev);
  }, []);

  const closeMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const openSidebar = useCallback((groupId, multipleItems = false) => {
    setActiveGroup(groupId);
    setHasMultipleItems(multipleItems);
  }, []);

  const closeSidebar = useCallback(() => {
    if (!isPinned) {
      setActiveGroup(null);
      setHasMultipleItems(false);
    }
  }, [isPinned]);

  // Secondary sidebar is visible when pinned and there's an active group with multiple items
  const isSecondarySidebarVisible = isPinned && activeGroup && hasMultipleItems;

  const value = {
    isPinned,
    setIsPinned,
    togglePinned,
    activeGroup,
    setActiveGroup,
    openSidebar,
    closeSidebar,
    hasMultipleItems,
    setHasMultipleItems,
    isSecondarySidebarVisible,
    isMobileMenuOpen,
    toggleMobileMenu,
    closeMobileMenu,
  };

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

export default SidebarContext;
